import { createFileRoute } from '@tanstack/react-router';
import AddFieldMapsPage from 'src/Administration/Metadata/MetadataFieldMaps/AddEditFieldMapsPages/AddFieldMapsPage';

export const Route = createFileRoute('/systemadmin/_layout/metadata/field-maps/new')({
  component: AddFieldMapsPage,
});
